export default __webpack_public_path__ + "static/media/cook4.0e7c17df.png";